import { AddIcon } from '@cycle-app/ui/icons';

import { Container, Content, StyledButton } from './RoadmapsEmpty.styles';

export const RoadmapsEmpty = ({ onClick }: { onClick: VoidFunction }) => {
  return (
    <Container>
      <Content>
        <p>
          No doc yet in this view
        </p>

        <StyledButton
          onClick={onClick}
        >
          <AddIcon size={12} />
          New doc
        </StyledButton>
      </Content>
    </Container>
  );
};
